import React from 'react'

function guides() {
  return (
    <div>
        <h1>GUIDES</h1>
    </div>
  )
}

export default guides